export default "__VITE_PUBLIC_ASSET__17145751__"